import { Component, Input, OnInit } from '@angular/core';
import TabBase from '../tab-base';

@Component({
    selector: 'app-tab-enrollments',
    templateUrl: './enrollments.component.html',
    styleUrls: ['./enrollments.component.scss'],
})
export class TabEnrollmentsComponent extends TabBase implements OnInit {
    /**
     * Parametros para listagem da classificação
     * @property { string } tournamentId - id do torneio
     * @property { categoryId } categoryId; - id da categoria
     */
    @Input() tournamentId: string;
    @Input() categoryId: string;

    enrollments: any;

    /* Paginação */
    perPage: number = 8;
    page: number = 1;

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.getEnrollments();
    }

    private getEnrollments() {
        this.tournamentService
            .getEnrollments(this.tournamentId, this.categoryId)
            .subscribe((response) => (this.enrollments = response.registers));
    }
}
